<template>
	<view class="">
		<view>
			<text>出淤泥而不染，濯清涟而不妖</text>
			<text>出淤泥而不染，濯清涟而不妖</text>
			<text>出淤泥而不染，濯清涟而不妖</text>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				popupShow: true
			}
		},
		methods: {
			
		}
	}
</script>

<style>

</style>
